import instance from "@/util/request"
import axios from 'axios'
import Cookies from 'js-cookie'

export function getAction (url, params) {
  return new Promise((resolve, reject) => {
    instance.get(url, { params: params }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export function postAction (url, data) {
  return new Promise((resolve, reject) => {
    instance.post(url, data).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 专利接口直接请求完整地址
export function patentAction (url, params) {
  return new Promise((resolve, reject) => {
    const token = Cookies.get('Admin-Token')
    axios.get('https://hnipex.com/kjpt/prod-api' + url, {
      params,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': 'Bearer ' + token } : {})
      },
      timeout: 100000
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}